import React, { Fragment, useEffect, useState } from 'react';
import NewOverlayLoader from '../../../../../components/PurchaseRequisition/common/NewOverlayLoader';
import Popup from '../../../../../components/Popup/Popup';
import Api from '../../../../../inc/Api';
import Settings from '../../../../../inc/Settings';
import axios from 'axios'; 
import { buildApiUrlForDropdown, getPopupMessageBasedOnStatus, validateWhereRulesWorkflowConditions } from '../../../../../inc/Validation';
import Button from '../../../../../components/inc/Button';
import Helper from '../../../../../inc/Helper';
import Collapse from '../../../../../components/inc/Collapse';
import DropDownInput from '../../../../../components/Forms/Dropdown';
import FormValidator from '../../../../../inc/FormValidator';
import Input from '../../../../../components/Forms/Input';

let cancelTokenSource = axios.CancelToken.source();
const ConditionalDataPopup = ({ language, currentNode, nodeLabel, onConditionalModalClose, checkInstance, save, addNode, actionValue, hideConditionalModal, mainModal, currentHandleId, workflowBodyId, onClickNode, fieldDictionaryData, existingConditions=[] , popupDetails, setPopupDetails, reloadParentGrid, setShowCreateModal}) => {
    const [apiCallBtn, setApiCallBtn] = useState(false);
    const [loadingApiResponse, setLoadingApiResponse] = useState(false);

    const [operatorApiData, setOperatorApiData] = useState([]);
    const [valuesData, setValuesData] = useState([]); 

    const { condition_id } = popupDetails;
    const getNodeId = () => `${+new Date()}`;

    useEffect(() => { 
        if(condition_id) {
            if (popupDetails?.field_id) {
                onChangeFieldValue({ target: { value: popupDetails.field_id, name: 'field_id' } }, true);
            };
        };
    }, []);

    let formValidator;

    const validationConfigure = () => {
        let formFieldConfig = [
            {name:'clause', displayName:Helper.getLabel(language,'clause','Clause'),types:['Required']}, 
            {name:'field_id', displayName:Helper.getLabel(language,'field_id','Field'),types:['Required']},
            {name:'operator', displayName:Helper.getLabel(language,'operator','Operator'),types:['Required']},
            {name:'value', displayName:Helper.getLabel(language,'value','Value'),types:['Required']}
        ];

        if(!formValidator) {
            formValidator = new FormValidator(formFieldConfig, language)
        }; 
    };

    validationConfigure();
    
    const buildPayloadForApi = () => ({
        clause: parseInt(popupDetails?.clause),
        field_id: parseInt(popupDetails?.field_id),
        operator: parseInt(popupDetails?.operator),
        value: popupDetails?.value
    });

    const saveWorkflowCondition = () => {
        const payload = buildPayloadForApi();

        let updateArray = [];
        let createArray = [];

        if(condition_id){
            updateArray = [{ ...payload, condition_id: parseInt(condition_id) }];
            createArray = [];
        } else {
            createArray = [payload];
            updateArray = [];
        } 

        Helper.createDebouncedAPIFunction(
            [() => executeUpdateWorkflowCondition(updateArray, createArray)],
            setApiCallBtn,
            cancelTokenSource
        )();
    };
 
    const executeCreateWorkflowCondition = async () => {
        const nodeID = getNodeId();
        try {
            let api = Api;
            api.setUserToken();
            const res = await api.axios().post(
                Settings.baseUrl + 'workflow-condition/create',
                {
                    body_id: +workflowBodyId,
                    node_id: nodeID,
                    label: nodeLabel,
                    parent_node_id: currentNode !== "1" ? +currentNode : null,
                    parent_condition: currentHandleId != null ? currentHandleId === "a" : null,
                    conditions: [buildPayloadForApi()]
                },
                { cancelToken: cancelTokenSource.token }
            );
            if (res.data.success) {
                Helper.alert(res.data.message);
                onPopupClose(false);
                hideConditionalModal(false);
                mainModal(false);
                addNode(currentNode, actionValue, currentHandleId, nodeID, nodeLabel);
                setTimeout(() => { save() }, 100);
            }
        } catch (err) {
            getPopupMessageBasedOnStatus(err);
        }
    };

    const executeUpdateWorkflowCondition = async (
        updateArray = [],
        createArray = []
    ) => {
        try {
            let api = Api;
            api.setUserToken();
            const res = await api.axios().post(
                Settings.baseUrl + 'workflow-condition/update',
                {
                    node_id: +onClickNode,
                    update_data: updateArray,
                    create_data: createArray
                },
                { cancelToken: cancelTokenSource.token }
            );
            if (res.data.success) {
                Helper.alert(res.data.message);
                onPopupClose();
            }
        } catch (err) {
            getPopupMessageBasedOnStatus(err);
        }
    };

    const onPopupClose = (resetNodeId=true) => { 
        reloadParentGrid();
        if(resetNodeId){ onConditionalModalClose() }
        setShowCreateModal(false);
    };

    const onChangeEvent = (evt) => {
        const { name, value } = evt?.target;
        setPopupDetails(prevState => { return { ...prevState, [name]: value }});
    };

    const loadValuesForField = async (selectedField) => {
        if (!selectedField) {
            setValuesData([]);
            return;
        }

        if (selectedField.field_type === typeMap.Boolean) {
            setValuesData(Settings.havingData);
            return;
        }

        if (selectedField.api_endpoint?.trim()) {
            try {
                setLoadingApiResponse(true);
                const url = buildApiUrlForDropdown(selectedField.api_endpoint);

                let api = Api;
                api.setUserToken();

                const res = await api.axios().get(url);

                const dropdownOptions = res.data?.data?.map(item => ({
                    value: item[selectedField.endpoint_key],
                    label: item[selectedField.endpoint_value]
                })) || [];

                setValuesData(dropdownOptions);
                setLoadingApiResponse(false);
            } catch (error) {
                getPopupMessageBasedOnStatus(error);
                setValuesData([]);
                setLoadingApiResponse(false);
            }
            setLoadingApiResponse(false);
            return;
        };

        setValuesData([]);
    };
    
    const onChangeFieldValue = (evt, preserveExisting = false) => {
        const { value } = evt?.target;

        const selectedField = fieldDictionaryData?.find((f) => f.field_id == value);

        let filteredOperators;
        if (selectedField?.api_endpoint || selectedField?.field_type == 1) { 
            filteredOperators = Settings.operatorData?.filter(op => op.value < 3);
        } else if (selectedField?.field_type == 3) {
            filteredOperators = Settings.operatorData?.filter(op => op.value === 1);
        } else {
            filteredOperators = Settings.operatorData;
        };

        loadValuesForField(selectedField);
        setOperatorApiData(filteredOperators); 
        setPopupDetails(prevState => ({
            ...prevState,
            field_id: value,
            operator: preserveExisting ? prevState.operator : '',
            value: preserveExisting ? prevState.value : ''
        }));
    };

    const handleSubmit = async () => { 
        if (!formValidator.isValid({ ...popupDetails })) {
            formValidator.displayMessage();
            formValidator.reset();
            return;
        }

        const payloadRow = { 
            clause: parseInt(popupDetails.clause),
            field_id: parseInt(popupDetails.field_id),
            operator: parseInt(popupDetails.operator),
            value: (popupDetails.value)
        };
 
        const isUpdate = Boolean(onClickNode);
        if (!validateWhereRulesWorkflowConditions(existingConditions, payloadRow, isUpdate)) {
            return;
        };

        if (!isUpdate) {
            Helper.createDebouncedAPIFunction(
                [executeCreateWorkflowCondition],
                setApiCallBtn,
                cancelTokenSource
            )();
        } else { 
            const instanceExist = await checkInstance();
            if (instanceExist) {
                Helper.alert("This workflow have instance, so you can't edit", 'error');
                return;
            };
            saveWorkflowCondition();
        };
    };

    const whereExists = existingConditions.some(
        cond => cond.clause === 1
    );

    const filteredClauseOptions = (Settings.conditionData || []).filter(option =>
        option.value !== 1 || !whereExists
    );

    const currentClauseOption = popupDetails.clause
        ? Settings.conditionData?.find(
            opt => opt.value == popupDetails.clause
        )
        : null;
 
    const clauseOptions = condition_id
        ? [
            ...filteredClauseOptions,
            ...(currentClauseOption &&
            !filteredClauseOptions.some(opt => opt.value == popupDetails.clause)
                ? [currentClauseOption]
                : [])
        ]
        : filteredClauseOptions;

    const typeMap = Settings.fieldTypeList?.reduce((map, ft) => {
        map[ft.label] = ft.value;
        return map;
    }, {}) || {};

    const selectedFieldObj = fieldDictionaryData
        ?.find(f => f.field_id == popupDetails.field_id);

    const isDropdownType = (() => {
        if (!selectedFieldObj) return false;
        const { field_type, api_endpoint } = selectedFieldObj;

        return (
            field_type === typeMap.Boolean ||
            (field_type === typeMap.Number && api_endpoint?.trim()) ||
            valuesData.length > 0
        );
    })();

    const isUDFField = (() => {
        if (!selectedFieldObj) return false;
        const { metadata, field_type } = selectedFieldObj;

        return (
            ((field_type === typeMap.Number) || ((field_type === typeMap.String)) && metadata?.isUDF === true)
        );
    })();

    const inputType = selectedFieldObj?.field_type === typeMap.Number ? 'number' : 'text';
    return (
        <Fragment> 
            { apiCallBtn || loadingApiResponse ? <NewOverlayLoader isPopupInTab={true} /> : null }
            <Popup
                autoOpen={true} width="752px"
                onClose={onPopupClose} 
            >
                <>
                    <div className='addDocumentNumber-body-buttons' style={{ justifyContent: 'flex-end' }}>
                        <Button
                            isDisable={apiCallBtn}                        
                            className={"blue-btn-style"}  
                            title={Helper.getLabel(language, "save", "Save & Close")}
                            onClick={handleSubmit}
                        />
                    </div> 

                    <Collapse
                        className="mt-4 mb-4" open={true}
                        title={Helper.getLabel(
                            language,
                            "workflow_conditions",
                            "Workflow Conditions"
                        )}
                    >
                        <div className='container-fluid'>
                            <div className='row'>
                                <div className='col-lg-6'>
                                    <DropDownInput isDisable={condition_id} options={clauseOptions} required={true} id='clause' label={Helper.getLabel(language,'clause',"Clause")} value={popupDetails.clause} name='clause' placeHolder='Select clause' onChange={onChangeEvent} reRenderRequired={true} />
                                </div>
                                <div className='col-lg-6'>
                                    <DropDownInput 
                                        options={fieldDictionaryData
                                            ?.map(item => {
                                            return {
                                                value: item.field_id,
                                                label: item.field_label
                                            }
                                        })}
                                        required={true}
                                        id='field_id' 
                                        label={Helper.getLabel(language,'field_id',"Field")} 
                                        value={popupDetails.field_id} 
                                        name='field_id'
                                        disableClear={true}
                                        onChange={onChangeFieldValue} 
                                        placeHolder='Select field' 
                                        reRenderRequired={true} 
                                    />
                                </div>
                                <div className='col-lg-6'>
                                    <DropDownInput isDisable={!popupDetails?.field_id} options={operatorApiData} required={true} id='operator' label={Helper.getLabel(language,'operator',"Operator")} value={popupDetails.operator} name='operator' onChange={onChangeEvent} placeHolder='Select operator' reRenderRequired={true} />
                                </div>
                                <div className="col-lg-6">
                                    {
                                        isUDFField && selectedFieldObj?.metadata?.multi_select_enum === false ? (
                                            <DropDownInput
                                                isDisable={!popupDetails?.field_id}
                                                options={selectedFieldObj?.metadata?.enum_values?.map(obj => ({ label: obj.enum_label, value: obj.enum_value })) || []}
                                                required={true}
                                                id="value"
                                                label={Helper.getLabel(language,'value','Value')}
                                                value={popupDetails.value ?? ''}
                                                name="value"
                                                onChange={onChangeEvent}
                                                placeHolder="Select value"
                                                reRenderRequired={true}
                                            />
                                    ) :
                                        isDropdownType ? (
                                            <DropDownInput
                                                isDisable={!popupDetails?.field_id}
                                                options={valuesData}
                                                required={true}
                                                id="value"
                                                label={Helper.getLabel(language,'value','Value')}
                                                value={popupDetails.value ?? ''}
                                                name="value"
                                                onChange={onChangeEvent}
                                                placeHolder="Select value"
                                                reRenderRequired={true}
                                            />
                                    ) : (
                                        <Input
                                            disable={!popupDetails?.field_id}
                                            required={true}
                                            inputType={inputType}
                                            id="value"
                                            label={Helper.getLabel(language,'value','Value')}
                                            value={popupDetails.value ?? ''}
                                            name="value"
                                            onChange={onChangeEvent}
                                            placeholder="Enter value"
                                        />
                                    )}
                                </div>
                            </div> 
                        </div>
                    </Collapse>
                </> 
            </Popup>
        </Fragment>
    )
};

export default ConditionalDataPopup;